import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Trash2 } from 'lucide-react';
import { MoneyInput } from '@/lib/MoneyInput';

export function SectionItems({ 
  titre,
  items,
  onModifierItem,
  onAjouterLigne,
  onSupprimerItem,
}) {
  const [afficherSousTotal, setAfficherSousTotal] = useState(true);

  const calculerSousTotal = () => {
    return items.reduce((sum, item) => sum + (parseFloat(item.montant) || 0), 0);
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle className="text-2xl text-center flex-1 font-bold">{titre}</CardTitle>
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id={`sous-total-${titre}`}
              checked={afficherSousTotal}
              onChange={(e) => setAfficherSousTotal(e.target.checked)}
              className="w-4 h-4"
            />
            <label htmlFor={`sous-total-${titre}`} className="text-sm cursor-pointer">
              Afficher sous-total
            </label>
          </div>
        </div>
      </CardHeader>
      
      <CardContent>
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-3 text-left font-semibold border">Description</th>
              <th className="p-3 text-right font-semibold border w-48">Total</th>
              <th className="p-3 border w-16"></th>
            </tr>
          </thead>
          <tbody className="bg-gray-50">
            {items.map((item, index) => (
              // ✅ FIX 2026-04-27: clé stable basée sur l'index (pas JSON.stringify qui
              // change à chaque keystroke et fait perdre le focus → "1 lettre à la fois")
              <tr key={item.id || item._id || `row-${index}`} className="border">
                <td className="p-2 border">
                  <Input
                    className="bg-white border-gray-300"
                    placeholder="Description..."
                    value={item.description || ''}
                    onChange={(e) => {
                      onModifierItem(index, 'description', e.target.value);
                    }}
                  />
                </td>
                <td className="p-2 border">
                  <MoneyInput
                    className="bg-white border-gray-300 text-right font-semibold"
                    value={item.montant}
                    onChange={(num) => onModifierItem(index, 'montant', num)}
                    data-testid={`item-montant-${index}`}
                  />
                </td>
                <td className="p-2 border text-center">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onSupprimerItem(index)}
                  >
                    <Trash2 className="w-4 h-4 text-red-600" />
                  </Button>
                </td>
              </tr>
            ))}
            
            {/* Sous-total */}
            {afficherSousTotal && (
              <tr className="bg-gray-200 font-bold border">
                <td className="p-3 text-left">Sous-total</td>
                <td className="p-3 text-right text-lg">{calculerSousTotal().toLocaleString('fr-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} $</td>
                <td></td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Bouton Ajouter */}
        <div className="mt-4">
          <Button
            type="button"
            className="bg-blue-600 hover:bg-blue-700 text-white w-full"
            onClick={onAjouterLigne}
          >
            + Ajouter une ligne
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
